import { config } from "@/config";
import { useFlow } from "@frigade/react";
import * as Frigade from "@frigade/react";
import OnboardingFlow from "./OnboardingFlow";

const OnboardingDemoAssignmentHintFlow = () => {
  const { flow } = useFlow(config.frigade.flows.demoAssignmentHint);

  if (flow?.isCompleted) {
    return null;
  }

  return (
    <OnboardingFlow>
      <Frigade.Tour
        flowId={config.frigade.flows.demoAssignmentHint}
        defaultOpen={true}
        sequential={false}
        dismissible={true}
        side="left"
      />
    </OnboardingFlow>
  );
};

export default OnboardingDemoAssignmentHintFlow;

